export default {"src":"/_next/static/media/nature-landscape.mono.c09e78d2.svg","height":333,"width":364,"blurWidth":0,"blurHeight":0};